import { formatDistanceStrict } from 'date-fns';
import { TFunction } from 'i18next';

import { ChipVariant } from '../assistants/components/config/Chip.tsx';

export const OUTCOME_VARIANTS: Record<string, ChipVariant> = {
    order_booked: 'success',
    rfq_booked: 'success',
    meeting_booked: 'success',
    note_sent: 'success',
    question_answered: 'success',
    forwarded: 'default',
    consent_denied: 'danger',
    hung_up: 'muted',
};

export const END_REASON_VARIANTS: Record<string, ChipVariant> = {
    normal_end: 'success',
    forwarded: 'default',
    consent_denied: 'danger',
    consent_denied_forwarded: 'danger',
    caller_hung_up: 'muted',
    error: 'danger',
};

export const SENTIMENT_VARIANTS: Record<string, ChipVariant> = {
    positive: 'success',
    neutral: 'default',
    negative: 'danger',
};

export const callerLabel = (record: any, t: TFunction): string =>
    record.callerName || record.callerPhoneNumber || (t('history.unknownCaller') as string);

export const callDuration = (record: any): string => {
    const start = record.callStartedAt || record.createdAt;
    if (!start || !record.finishedAt) return '—';
    return formatDistanceStrict(new Date(start), new Date(record.finishedAt));
};
